var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#32E2DF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "black",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_16_15",
    maskUnits: "userSpaceOnUse",
    x: 10.3549,
    y: 5.75,
    width: 19,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.3549,
    y: 5.75,
    width: 19,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.409 24.75L16.7172 20.4552H23.2952L24.6034 24.75H28.7254L22.3572 6.63277H17.6798L11.287 24.75H15.409ZM17.6305 17.2464L18.9387 13.0503C19.0209 12.7706 19.132 12.4127 19.2719 11.9766C19.4035 11.5323 19.5393 11.0839 19.6791 10.6314C19.8108 10.1706 19.9177 9.7716 20 9.43427C20.0823 9.7716 20.1975 10.1912 20.3456 10.6931C20.4855 11.1868 20.6212 11.6557 20.7528 12.1C20.8845 12.5443 20.9791 12.8611 21.0367 13.0503L22.3326 17.2464H17.6305Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.409 24.75L16.7172 20.4552H23.2952L24.6034 24.75H28.7254L22.3572 6.63277H17.6798L11.287 24.75H15.409ZM17.6305 17.2464L18.9387 13.0503C19.0209 12.7706 19.132 12.4127 19.2719 11.9766C19.4035 11.5323 19.5393 11.0839 19.6791 10.6314C19.8108 10.1706 19.9177 9.7716 20 9.43427C20.0823 9.7716 20.1975 10.1912 20.3456 10.6931C20.4855 11.1868 20.6212 11.6557 20.7528 12.1C20.8845 12.5443 20.9791 12.8611 21.0367 13.0503L22.3326 17.2464H17.6305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.409 24.75L15.7844 24.8644L15.6997 25.1425H15.409V24.75ZM16.7172 20.4552L16.3418 20.3408L16.4265 20.0627H16.7172V20.4552ZM23.2952 20.4552V20.0627H23.5859L23.6706 20.3408L23.2952 20.4552ZM24.6034 24.75V25.1425H24.3126L24.2279 24.8644L24.6034 24.75ZM28.7254 24.75L29.0957 24.6199L29.2794 25.1425H28.7254V24.75ZM22.3572 6.63276V6.24029H22.6353L22.7275 6.50262L22.3572 6.63276ZM17.6798 6.63276L17.3097 6.50217L17.4021 6.24029H17.6798V6.63276ZM11.287 24.75V25.1425H10.7323L10.9169 24.6194L11.287 24.75ZM17.6305 17.2464V17.6389H17.097L17.2558 17.1296L17.6305 17.2464ZM18.9387 13.0503L19.3152 13.1611L19.3133 13.1671L18.9387 13.0503ZM19.2719 11.9766L19.6483 12.0881L19.6456 12.0965L19.2719 11.9766ZM19.6791 10.6314L20.0566 10.7392L20.0541 10.7473L19.6791 10.6314ZM20 9.43427L19.6187 9.34127H20.3813L20 9.43427ZM20.3456 10.6931L20.722 10.582L20.7232 10.5861L20.3456 10.6931ZM20.7528 12.1L20.3765 12.2115L20.7528 12.1ZM21.0367 13.0503L20.6617 13.1661L20.6612 13.1646L21.0367 13.0503ZM22.3326 17.2464L22.7076 17.1306L22.8645 17.6389H22.3326V17.2464ZM15.0336 24.6356L16.3418 20.3408L17.0926 20.5695L15.7844 24.8644L15.0336 24.6356ZM16.7172 20.0627H23.2952V20.8477H16.7172V20.0627ZM23.6706 20.3408L24.9788 24.6356L24.2279 24.8644L22.9197 20.5695L23.6706 20.3408ZM24.6034 24.3575H28.7254V25.1425H24.6034V24.3575ZM28.3552 24.8801L21.987 6.76291L22.7275 6.50262L29.0957 24.6199L28.3552 24.8801ZM22.3572 7.02524H17.6798V6.24029H22.3572V7.02524ZM18.0499 6.76336L11.6571 24.8806L10.9169 24.6194L17.3097 6.50217L18.0499 6.76336ZM11.287 24.3575H15.409V25.1425H11.287V24.3575ZM17.2558 17.1296L18.564 12.9335L19.3133 13.1671L18.0051 17.3632L17.2558 17.1296ZM18.5621 12.9396C18.6457 12.6556 18.7578 12.2943 18.8982 11.8567L19.6456 12.0965C19.5062 12.531 19.3962 12.8856 19.3152 13.1611L18.5621 12.9396ZM18.8956 11.8651C19.0277 11.4193 19.1639 10.9694 19.3042 10.5155L20.0541 10.7473C19.9147 11.1984 19.7794 11.6453 19.6482 12.0881L18.8956 11.8651ZM19.3018 10.5236C19.4325 10.066 19.538 9.67218 19.6187 9.34127L20.3813 9.52727C20.2975 9.87103 20.1891 10.2752 20.0565 10.7392L19.3018 10.5236ZM20.3813 9.34127C20.4616 9.67034 20.5749 10.0835 20.722 10.582L19.9692 10.8042C19.8201 10.299 19.703 9.87287 19.6187 9.52727L20.3813 9.34127ZM20.7232 10.5861C20.8627 11.0784 20.998 11.5459 21.1292 11.9885L20.3765 12.2115C20.2444 11.7656 20.1082 11.2951 19.968 10.8001L20.7232 10.5861ZM21.1292 11.9885C21.2608 12.4328 21.355 12.7483 21.4122 12.936L20.6612 13.1646C20.6032 12.9738 20.5082 12.6558 20.3765 12.2115L21.1292 11.9885ZM21.4117 12.9345L22.7076 17.1306L21.9576 17.3622L20.6617 13.1661L21.4117 12.9345ZM22.3326 17.6389H17.6305V16.8539H22.3326V17.6389Z",
    fill: "black",
    mask: "url(#path-3-outside-1_16_15)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_15",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_15",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.ac723b404fb3c75f90009d811e7c3d00.svg";
export { ForwardRef as ReactComponent };